import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { img } from "@/lib/api";
import { Reveal, Eyebrow, MaskedLine } from "@/components/Reveal";

const COLLECTIONS = [
  {
    n: "001", title: "The Founders Drop", desc: "The first release. Heavyweight tees and 450 GSM fleece — numbered, limited, never repressed.",
    image: "legacy-tee.jpg", to: "/shop?drop=new", tag: "Live Now",
  },
  {
    n: "002", title: "Acid Series", desc: "Hand acid-washed garments. No two pieces identical — like the paths of the people who wear them.",
    image: "panther-tee.jpg", to: "/shop?category=Tees", tag: "Sold Out — Restock TBA",
  },
  {
    n: "003", title: "Everglades Capsule", desc: "Waxed canvas and wetland tones. A tribute to Florida — where the brand was built in silence.",
    image: "everglades-jacket.jpg", to: "/shop?category=Outerwear", tag: "Coming Soon",
  },
];

export default function Collections() {
  return (
    <div className="pt-16" data-testid="collections-page">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 sm:pt-24 pb-16">
        <Reveal><Eyebrow>Capsules & Seasons</Eyebrow></Reveal>
        <h1 className="font-display font-extrabold uppercase tracking-tight text-5xl sm:text-7xl mt-4 leading-[0.9]">
          <MaskedLine delay={0.1}><span className="text-cream">Collec</span></MaskedLine>
          <MaskedLine delay={0.2}><span className="text-outline">tions</span></MaskedLine>
        </h1>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-24 sm:pb-32 space-y-6">
        {COLLECTIONS.map((c, i) => (
          <Reveal key={c.n} delay={i * 0.05}>
            <Link to={c.to} className="group grid grid-cols-1 md:grid-cols-12 border border-white/10 hover:border-gold/40 transition-colors duration-500 overflow-hidden" data-testid={`collection-card-${c.n}`}>
              <div className="md:col-span-5 aspect-[4/3] md:aspect-auto overflow-hidden bg-noir-card">
                <img src={img(c.image)} alt={c.title} loading="lazy" className="w-full h-full object-cover transition-transform duration-[1.4s] ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-[1.05]" />
              </div>
              <div className="md:col-span-7 p-8 sm:p-14 flex flex-col justify-center">
                <div className="flex items-center gap-4 mb-6">
                  <span className="font-mono2 text-gold text-sm">{c.n}</span>
                  <span className="font-mono2 text-[9px] tracking-[0.25em] uppercase text-cream/50 border border-white/15 px-2.5 py-1">{c.tag}</span>
                </div>
                <h2 className="font-display text-2xl sm:text-4xl font-bold uppercase group-hover:text-gold transition-colors duration-300">{c.title}</h2>
                <p className="mt-4 text-cream/50 text-sm leading-relaxed max-w-md">{c.desc}</p>
                <span className="mt-8 inline-flex items-center gap-2 font-mono2 text-[10px] tracking-[0.25em] uppercase text-gold">
                  Explore <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </span>
              </div>
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  );
}
